import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaTrash } from "react-icons/fa";
import { MdFamilyRestroom } from "react-icons/md";
import { toast } from "react-toastify";
import Select from "react-select";
import {
  getProfile,
  updateProfile,
  updateFamilyDetails,
  updateProfessionalDetails, getSubCaste
} from "../../store/slices/profile";
import { useDispatch, useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import { CgProfile } from "react-icons/cg";

const READ_ONLY_KEYS = ["name", "dob", "profileFor"];

const initData = {
  name: "",
  dob: "",
  gender: "Male",
  profileFor: "",
  marital: "",
  height: "",
  bloodGroup: "",
  complexion: "",
  Language: [],
  hobbies: [],
  cadre: "",

  subcaste: "",
  motherTongue: "",
  nativedistrict: "",

  about: "",

  education: "",
  college: "",
  occupation: "",
  company: "",
  income: "",
  workLocation: "",
  employmentType: "",

  fatherName: "",
  motherName: "",
  fatherOcc: "",
  motherOcc: "",
  familyType: "",
  siblings: [],

  currentAddress: "",
  currentCity: "",
  currentState: "",
  currentCountry: "",
  planningtoSettle: "",
  staying: "",

  permanentAddress: "",
  permanentCity: "",
  permanentState: "",
  permanentCountry: "",

  city: "",
  state: "",
};

const mapProfile = (profile = {}) => ({
  ...initData,

  name: profile.name ?? initData.name,
  dob: profile.dob ?? initData.dob,
  profileFor: profile.profileFor ?? initData.profileFor,

  height: profile.profile?.height ?? initData.height,
  marital: profile.profile?.maritalStatus ?? initData.marital,
  bloodGroup: profile.profile?.bloodGroup ?? initData.bloodGroup,
  complexion: profile.profile?.complexion ?? initData.complexion,
  Language:
    Array.isArray(profile.profile?.languagesKnown) &&
      profile.profile.languagesKnown.length > 0
      ? profile.profile.languagesKnown
      : initData.Language,

  hobbies:
    Array.isArray(profile.profile?.hobbies) &&
      profile.profile.hobbies.length > 0
      ? profile.profile.hobbies
      : initData.hobbies,

  subcaste: profile.profile?.subCaste ?? initData.subcaste,
  motherTongue: profile.profile?.motherTongue ?? initData.motherTongue,
  nativedistrict: profile.profile?.nativeDistrict ?? initData.nativedistrict,

  about: profile.profile?.aboutMe ?? initData.about,

  education: profile.profession?.education ?? initData.education,
  college: profile.profession?.college ?? initData.college,
  occupation: profile.profession?.occupation ?? initData.occupation,
  company: profile.profession?.companyName ?? initData.company,
  income: profile.profession?.annualIncome ?? initData.income,
  workLocation: profile.profession?.workLocation ?? initData.workLocation,
  employmentType: profile.profession?.employmentType ?? initData.employmentType,
  cadre: profile.profession?.cadre ?? initData.cadre,

  fatherName: profile.family?.fatherName ?? initData.fatherName,
  motherName: profile.family?.motherName ?? initData.motherName,
  fatherOcc: profile.family?.fatherOccupation ?? initData.fatherOcc,
  motherOcc: profile.family?.motherOccupation ?? initData.motherOcc,
  familyType: profile.family?.familyType ?? initData.familyType,
  siblings: Array.isArray(profile.family?.siblings)
    ? profile.family.siblings.map((s) => ({
      name: s.name || "",
      occupation: s.occupation || "",
      maritalStatus: s.maritalStatus || "",
    }))
    : initData.siblings,

  currentAddress:
    profile.profile?.presentAddress?.address ?? initData.currentAddress,
  currentCity: profile.profile?.presentAddress?.city ?? initData.currentCity,
  currentState: profile.profile?.presentAddress?.state ?? initData.currentState,
  currentCountry:
    profile.profile?.presentAddress?.country ?? initData.currentCountry,
  planningtoSettle:
    profile.profile?.presentAddress?.planningtoSettle ??
    initData.planningtoSettle,
  staying: profile.profile?.presentAddress?.staying ?? initData.staying,

  permanentAddress:
    profile.profile?.permanentAddress?.address ?? initData.permanentAddress,
  permanentCity:
    profile.profile?.permanentAddress?.city ?? initData.permanentCity,
  permanentState:
    profile.profile?.permanentAddress?.state ?? initData.permanentState,
  permanentCountry:
    profile.profile?.permanentAddress?.country ?? initData.permanentCountry,

  city: profile.profile?.presentAddress?.city ?? initData.city,
  state: profile.profile?.presentAddress?.state ?? initData.state,
});

const mapSectionToPayload = (sectionKey, draft) => {
  switch (sectionKey) {
    case "personal":
      return {
        actionType: "updateProfile",
        payload: {
          height: draft.height,
          complexion: draft.complexion,
          bloodGroup: draft.bloodGroup,
          maritalStatus: draft.marital,

          languagesKnown: Array.isArray(draft.Language)
            ? draft.Language
            : [draft.Language].filter(Boolean),

          hobbies: Array.isArray(draft.hobbies)
            ? draft.hobbies
            : [draft.hobbies].filter(Boolean),
        },
      };

    case "religious":
      return {
        actionType: "updateProfile",
        payload: {
          subCaste: draft.subcaste,
          motherTongue: draft.motherTongue,
          nativeDistrict: draft.nativedistrict,
        },
      };

    case "about":
      return {
        actionType: "updateProfile",
        payload: { aboutMe: draft.about },
      };

    case "currentlocation":
      return {
        actionType: "updateProfile",
        payload: {
          presentAddress: {
            address: draft.currentAddress,
            city: draft.currentCity,
            state: draft.currentState,
            country: draft.currentCountry,
            planningtoSettle: draft.planningtoSettle,
            staying: draft.staying,
          },
        },
      };

    case "permanentlocation":
      return {
        actionType: "updateProfile",
        payload: {
          permanentAddress: {
            address: draft.permanentAddress,
            city: draft.permanentCity,
            state: draft.permanentState,
            country: draft.permanentCountry,
          },
        },
      };

    case "family":
      return {
        actionType: "updateFamilyDetails",
        payload: {
          fatherName: draft.fatherName,
          fatherOccupation: draft.fatherOcc,
          motherName: draft.motherName,
          motherOccupation: draft.motherOcc,
          familyType: draft.familyType,
          siblings: Array.isArray(draft.siblings)
            ? draft.siblings.map((s) => ({
              name: s.name,
              occupation: s.occupation,
              maritalStatus: s.maritalStatus,
            }))
            : [],
        },
      };

    case "education":
      return {
        actionType: "updateProfessionalDetails",
        payload: {
          education: draft.education,
          college: draft.college,
          occupation: draft.occupation,
          companyName: draft.company,
          annualIncome: draft.income,
          workLocation: draft.workLocation,
          employmentType: draft.employmentType,
          cadre: draft.cadre,
        },
      };

    default:
      return null;
  }
};

const sections = [
  {
    key: "personal",
    icon: "👤",
    iconBg: "#fde8f0",
    title: "Personal Details",
    subtitle: "Basic personal information",
    fields: [
      { key: "name", label: "Name", type: "input" },
      { key: "dob", label: "Date of Birth", type: "date" },
      {
        key: "profileFor",
        label: "Profile Created For",
        type: "select",
        options: ["My Self", "Son", "Brother", "Friend", "Relative"],
      },
      {
        key: "Language",
        label: "Languages Known",
        type: "select",
        multiple: true,
        options: ["Kannada", "Marathi", "Tamil", "English", "Hindi", "Telugu"],
      },
      {
        key: "hobbies",
        label: "Hobbies",
        type: "select",
        multiple: true,
        options: [
          "Reading",
          "Writing",
          "Traveling",
          "Cooking",
          "Music",
          "Singing",
          "Dancing",
          "Photography",
          "Painting",
          "Gardening",
          "Yoga",
          "Meditation",
          "Gym",
          "Fitness",
          "Running",
          "Cycling",
          "Swimming",
          "Cricket",
          "Football",
          "Badminton",
          "Chess",
          "Movies",
          "Shopping",
          "Fashion",
          "Pets",
          "Nature",
          "Hiking",
          "Trekking",
          "Blogging",
          "Social Service",
          "Technology"
        ],
      },
      {
        key: "marital",
        label: "Marital Status",
        type: "select",
        options: ["Unmarried", "Divorced", "Widowed", "Awaiting Divorce"],
      },
      {
        key: "bloodGroup",
        label: "Blood Group",
        type: "select",
        options: ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"],
      },
      {
        key: "complexion",
        label: "Complexion",
        type: "select",
        options: ["Very Fair", "Fair", "Wheatish", "Wheatish Brown", "Dark"],
      },
      {
        key: "height",
        label: "Height",
        type: "select",
        options: [
          "4'6\"",
          "4'7\"",
          "4'8\"",
          "4'9\"",
          "4'10\"",
          "4'11\"",
          "5'0\"",
          "5'1\"",
          "5'2\"",
          "5'3\"",
          "5'4\"",
          "5'5\"",
          "5'6\"",
          "5'7\"",
          "5'8\"",
          "5'9\"",
          "5'10\"",
          "5'11\"",
          "6'0\"",
          "6'1\"",
          "6'2\"",
          "6'3\"",
          "6'4\"",
          "6'5\"",
          "6'6\"",
          "6'7\"",
          "6'8\"",
          "6'9\"",
          "6'10\"",
          "6'11\"",
          "7'",
        ],
      },
    ],
  },
  {
    key: "religious",
    icon: "🪔",
    iconBg: "#fef9ec",
    title: "Religious & Cultural",
    subtitle: "Caste and cultural background",
    fields: [
      { key: "subcaste", label: "Sub-Caste", type: "input" },
      {
        key: "motherTongue",
        label: "Mother Tongue",
        type: "select",
        options: ["Kannada", "Marathi", "Hindi", "Tamil", "Telugu"],
      },
      { key: "nativedistrict", label: "Native District", type: "input" },
    ],
  },
  {
    key: "education",
    icon: "🎓",
    iconBg: "#e8f0fd",
    title: "Education & Career",
    subtitle: "Professional background",
    fields: [
      {
        key: "education",
        label: "Education",
        type: "select",
        options: [
          "Aeronautical Engineering",
          "B.Arch",
          "BCA",
          "B.E/B.Tech",
          "B.Plan",
          "Other Engineering",
          "B.A",
          "B.Com",
          "B.Sc",
          "B.S.W",
          "BFA",
          "B.Ed",
          "M.A",
          "M.Sc",
          "MBA",
          "MCA",
          "M.E/M.Tech",
          "M.Sc Eng.",
          "M.Arch",
          "PGDCA",
          "Other Master",
          "CA",
          "CS",
          "CFA",
          "ICWA",
          "PHD",
          "BAMS",
          "BDS",
          "BBA",
          "BHM",
          "MBBS",
          "B.Pharm",
          "M.Pharm",
          "Diploma",
          "PUC",
          "High School",
        ],
      },
      { key: "college", label: "College / University", type: "input" },
      {
        key: "employmentType",
        label: "Employment Type",
        type: "select",
        options: [
          "Private",
          "State Government",
          "Central Government",
          "PSU",
          "Self Employed",
          "Business",
          "Not Working",
          "Defence",
          "Unemployed",
          "Student",
          "Entrepreneur",
          "Freelance/ Consultant",
          "Legal Profession",
        ],
      },
      {
        key: "cadre",
        label: "Cadre",
        type: "input",
      },
      { key: "occupation", label: "Designation", type: "input" },
      { key: "company", label: "Organisaion", type: "input" },

      {
        key: "income",
        label: "Annual Income",
        type: "select",
        options: [
          "0-1 Lakh",
          "1-2 Lakhs",
          "2-3 Lakhs",
          "3-4 Lakhs",
          "4-5 Lakhs",
          "5-6 Lakhs",
          "6-7 Lakhs",
          "7-8 Lakhs",
          "8-9 Lakhs",
          "9-10 Lakhs",
          "10-15 Lakhs",
          "15-20 Lakhs",
          "20-25 Lakhs",
          "25-30 Lakhs",
          "30-35 Lakhs",
          "35-40 Lakhs",
          "40-45 Lakhs",
          "45-50 Lakhs",
          "50-60 Lakhs",
          "60-70 Lakhs",
          "70-80 Lakhs",
          "80-90 Lakhs",
          "90 Lakhs- 1 Crore",
          "1 Crore & Above",
        ],
      },
      { key: "workLocation", label: "Work Location", type: "input" },
    ],
  },
  {
    key: "family",
    icon: "🏠",
    iconBg: "#e8f5f0",
    title: "Family Details",
    subtitle: "Family background and status",
    fields: [
      { key: "fatherName", label: "Father's Name", type: "input" },
      { key: "motherName", label: "Mother's Name", type: "input" },
      {
        key: "familyType",
        label: "Family Type",
        type: "select",
        options: ["Nuclear", "Joint", "Extended", "Single-Parent Family"],
      },
      { key: "fatherOcc", label: "Father's Occupation", type: "input" },
      { key: "motherOcc", label: "Mother's Occupation", type: "input" },


      {
        key: "siblings",
        label: "Siblings",
        type: "siblings",
        min: 0,
        max: 10,
      },
    ],
  },

  {
    key: "currentlocation",
    icon: "📍",
    iconBg: "#fdf0f0",
    title: "Current Address",
    subtitle: "Current residence details",
    fields: [
      { key: "currentAddress", label: "Current Address", type: "textarea" },
      { key: "currentCity", label: "City", type: "input" },
      { key: "currentState", label: "State", type: "input" },
      { key: "currentCountry", label: "Country", type: "input" },
      {
        key: "planningtoSettle",
        label: "Planning to Settle Here?",
        type: "select",
        options: ["Yes", "No", "Maybe"],
      },
      {
        key: "staying",
        label: "Staying As",
        type: "select",
        options: ["Own", "Rent", "With Parents", "PG", "Company Provided"],
      },
    ],
  },
  {
    key: "permanentlocation",
    icon: "📍",
    iconBg: "#fdf0f0",
    title: "Permanent Address",
    subtitle: "Permanent residence details",
    fields: [
      {
        key: "permanentAddress",
        label: "Permanent Address",
        type: "textarea",
      },
      { key: "permanentCity", label: "City", type: "input" },
      { key: "permanentState", label: "State", type: "input" },
      { key: "permanentCountry", label: "Country", type: "input" },
    ],
  },
];

function SectionCard({ section, data, onSave }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState({ ...data });
  const [saved, setSaved] = useState(false);
  const [error, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const [searchText, setSearchText] = useState("");

  const dispatch = useDispatch();
  const { subcaste } = useSelector((state) => state.profile);

  useEffect(() => {
    setDraft({ ...data });
  }, [data]);

  const formatLabel = (label) => {
    if (!label) return "";
    return label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
  };

  const handleChange = (e, type = "input") => {
    const { name, value, dataset } = e.target;
    const label = formatLabel(dataset.label || name);

    setDraft((d) => ({ ...d, [name]: value }));
    if (name === "subcaste") {
      setSearchText(value);
    }

    let err = "";
    if (!value || !value.toString().trim()) {
      err =
        type === "select"
          ? `Please select ${label.toLowerCase()}`
          : `Please enter ${label.toLowerCase()}`;
    }
    if (type === "date" && value) {
      const today = new Date();
      const dob = new Date(value);
      let age = today.getFullYear() - dob.getFullYear();
      const m = today.getMonth() - dob.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;
      if (age < 18) err = "Minimum age is 18";
      else if (age > 60) err = "Maximum age is 60";
    }
    if (name === "employmentType") {
      setDraft((d) => ({
        ...d,
        employmentType: value,
        cadre: "", // reset cadre
      }));
      return;
    }
    setErrors((prev) => ({ ...prev, [name]: err }));
  };

  useEffect(() => {
    const keyword = searchText.trim();

    if (keyword.length < 2) return;

    const timer = setTimeout(() => {
      dispatch(getSubCaste({ search: keyword }));
    }, 300);

    return () => clearTimeout(timer);
  }, [searchText, dispatch]);

  const handleSave = async () => {
    let newErrors = {};
    let hasError = false;

    const getErrorMessage = (field) => {
      if (field.type === "select")
        return `Please select ${field?.label.toLowerCase()}`;
      if (field.type === "date")
        return `Please choose ${field?.label.toLowerCase()}`;
      return `Please enter ${field?.label.toLowerCase()}`;
    };

    const GOVERNMENT_TYPES = ["State Government", "Central Government"];
    const isGovernmentEmployee = GOVERNMENT_TYPES.includes(draft?.employmentType);

    section.fields
      .filter(
        (f) =>
          !READ_ONLY_KEYS.includes(f.key) &&
          f.type !== "siblings" &&
          f.type !== "textarea",
      )
      .forEach((f) => {
        //  Skip cadre validation if employment type is NOT government
        if (f.key === "cadre" && !isGovernmentEmployee) return;

        const value = draft?.[f.key];

        if (!value || !value.toString().trim()) {
          newErrors[f.key] = getErrorMessage(f);
          hasError = true;
        }
      });

    setErrors(newErrors);

    if (hasError) {
      toast.error("Please fill all required fields");
      return;
    }

    setSaving(true);
    try {
      await onSave(section.key, draft);
      setEditing(false);
      setSaved(true);
      setTimeout(() => setSaved(false), 2700);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setDraft({ ...data });
    setEditing(false);
    setErrors({});
  };

  const renderField = (f) => {
    // Read-only
    if (READ_ONLY_KEYS.includes(f.key)) {
      const displayValue =
        f.key === "dob" && data[f.key]
          ? new Date(data[f.key]).toLocaleDateString("en-IN", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })
          : data[f.key] || "—";
      return <div className="ep-readonly-value">{displayValue}</div>;
    }

    // Multi-select
    if (f.type === "select" && f.multiple) {
      return (
        <Select
          isMulti
          isSearchable
          closeMenuOnSelect={false}
          className="ep-react-select"
          classNamePrefix="ep-select"
          placeholder={`Select ${f.label}`}
          options={f.options
            .slice()
            .sort((a, b) => a.localeCompare(b))
            .map((item) => ({
              value: item,
              label: item,
            }))}
          value={(draft[f.key] || []).map((item) => ({
            value: item,
            label: item,
          }))}
          onChange={(selected) =>
            setDraft((prev) => ({
              ...prev,
              [f.key]: selected ? selected.map((i) => i.value) : [],
            }))
          }
        />
      );
    }

    if (f.type === "select")
      return (
        <>
          <Select
            className="ep-react-select"
            classNamePrefix="ep-select"
            isSearchable
            placeholder={`Select ${f.label}`}
            options={(f.key === "height" ||
              f.key === "income" ||
              f.key === "bloodGroup"
              ? f.options
              : [...f.options].sort((a, b) => a.localeCompare(b))
            ).map((item) => ({
              value: item,
              label: item,
            }))}
            value={
              draft[f.key]
                ? {
                  value: draft[f.key],
                  label: draft[f.key],
                }
                : null
            }
            onChange={(selected) =>
              setDraft((prev) => ({
                ...prev,
                [f.key]: selected ? selected.value : "",
              }))
            }
          />

          {error[f.key] && (
            <small className="ep-error">
              {error[f.key]}
            </small>
          )}
        </>
      );

    // Siblings
    if (f.type === "siblings") {
      const siblings = Array.isArray(draft.siblings) ? draft.siblings : [];

      const handleSiblingChange = (index, field, value) => {
        const updated = [...siblings];
        updated[index][field] = value;
        setDraft({ ...draft, siblings: updated });
      };
      const addSibling = () => {
        if (siblings.length >= f.max) return;
        setDraft({
          ...draft,
          siblings: [...siblings, { name: "", occupation: "", maritalStatus: "" }],
        });
      };
      const removeSibling = (index) => {
        setDraft({
          ...draft,
          siblings: siblings.filter((_, i) => i !== index),
        });
      };

      return (
        <div>
          {siblings.map((sib, i) => (
            <div key={i} className="sib-card d-flex flex-wrap">
              <input
                className="ep-input my-1"
                placeholder="Name"
                value={sib.name}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                  handleSiblingChange(i, "name", value);
                }}
                maxLength={30}
              />
              <input
                className="ep-input my-1"
                placeholder="Occupation"
                value={sib.occupation}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                  handleSiblingChange(i, "occupation", value);
                }}
                maxLength={40}
              />
              <select
                className="ep-select my-1"
                value={sib.maritalStatus}
                onChange={(e) =>
                  handleSiblingChange(i, "maritalStatus", e.target.value)
                }
              >
                <option value="">Marital Status</option>
                <option>Married</option>
                <option>Unmarried</option>
                <option>Divorced</option>
                <option>Widowed</option>
              </select>
              <button
                type="button"
                className="my-1 mx-1 ep-input ep-sib-remove-btn"
                onClick={() => removeSibling(i)}
              >
                <FaTrash size={15} color="rgb(123, 0, 0)" />
              </button>
            </div>
          ))}
          <button
            type="button"
            className="mx-1 d-flex ep-input ep-sib-add-btn"
            onClick={addSibling}
            disabled={siblings.length >= f.max}
          >
            ➕<MdFamilyRestroom size={20} />
          </button>
        </div>
      );
    }

    // Date
    if (f.type === "date")
      return (
        <>
          <input
            className="ep-input"
            type="date"
            name={f.key}
            value={draft[f.key] || ""}
            onChange={(e) => handleChange(e, "date")}
            data-label={f.label}
          />
          {error[f.key] && <small className="ep-error">{error[f.key]}</small>}
        </>
      );

    // Textarea
    if (f.type === "textarea")
      return (
        <>
          <textarea
            className="ep-textarea"
            name={f.key}
            value={draft[f.key] || ""}
            onChange={(e) => handleChange(e, "input")}
            data-label={f.label}
            placeholder={f.placeholder || `Enter ${f.label.toLowerCase()}`}
            maxLength={150}
          />
          {error[f.key] && <small className="ep-error">{error[f.key]}</small>}
        </>
      );


    if (f.key === "subcaste") {
      return (
        <div style={{ position: "relative" }}>
          <input
            className="ep-input"
            name="subcaste"
            value={draft.subcaste || ""}
            autoComplete="off"
            placeholder="Enter sub caste"
            data-label={f.label}
            onChange={(e) => {
              handleChange(e, "input");
              setSearchText(e.target.value);
            }}
          />

          {searchText.trim().length >= 2 && subcaste.length > 0 && (
            <div className="ep-autocomplete">
              {subcaste.map((item, index) => (
                <div
                  key={item._id || index}
                  className="ep-autocomplete-item"
                  onClick={() => {
                    setDraft((prev) => ({
                      ...prev,
                      subcaste: item.name,
                    }));

                    setSearchText("");
                  }}
                >
                  {item.name}
                </div>
              ))}
            </div>
          )}

          {error[f.key] && (
            <small className="ep-error">{error[f.key]}</small>
          )}
        </div>
      );
    }

    return (
      <>
        <input
          className="ep-input"
          name={f.key}
          value={draft[f.key] || ""}
          onChange={(e) => {

            let value = e.target.value.replace(/[^a-zA-Z,\s]/g, "");


            e.target.value = value;

            handleChange(e, "input");
          }}
          data-label={f.label}
          placeholder={`Enter ${f.label.toLowerCase()}`}
          maxLength={50}
        />
        {error[f.key] && <small className="ep-error">{error[f.key]}</small>}
      </>
    );
  };


  return (
    <div className="ep-section">
      {/* Header */}
      <div className="ep-sec-header">
        <div className="ep-sec-left">
          <div className="ep-sec-icon" style={{ background: section.iconBg }}>
            {section.icon}
          </div>
          <div>
            <div className="ep-sec-title">{section.title}</div>
            <div className="ep-sec-subtitle">{section.subtitle}</div>
          </div>
        </div>
        <button
          className={`ep-edit-btn${editing ? " editing" : ""}`}
          onClick={() => (editing ? handleCancel() : setEditing(true))}
        >
          {editing ? "✕ Cancel" : "✎ Edit"}
        </button>
      </div>

      {/* VIEW MODE */}
      {!editing && (
        <div className="ep-view">
          <div className="ep-detail-grid">
            {section.fields
              .filter((f) => {
                //  Hide cadre unless employment type is government
                if (f.key === "cadre") {
                  const GOVERNMENT_TYPES = ["State Government", "Central Government"];
                  return GOVERNMENT_TYPES.includes(data?.employmentType);
                }
                return true;
              })
              .map((f) => (
                <div key={f.key} className="ep-detail-item">
                  <div className="ep-detail-lbl">{f.label}</div>
                  <div className={`ep-detail-val${!data[f.key] ? " empty" : ""}`}>
                    {f.type === "siblings" ? (
                      (() => {
                        const sibs = Array.isArray(data.siblings)
                          ? data.siblings
                          : [];
                        return sibs.length === 0
                          ? "Not specified"
                          : sibs.map((sib, i) => (
                            <div key={i} className="ep-sib-row">
                              <span className="ep-sib-num">{i + 1}.</span>
                              <span className="ep-sib-name">
                                <strong>{sib.name}</strong>
                              </span>
                              <span className="ep-sib-occ">
                                {sib.occupation}
                              </span>
                              <span
                                className={`ep-sib-maritalStatus ${sib.maritalStatus}`}
                              >
                                (
                                {sib.maritalStatus}
                                )
                              </span>
                            </div>
                          ));
                      })()
                    ) : f.key === "dob" && data[f.key] ? (
                      new Date(data[f.key]).toLocaleDateString("en-IN", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })
                    ) : f.type === "select" && f.multiple ? (
                      Array.isArray(data[f.key]) && data[f.key].length > 0 ? (
                        <div className="ep-view-chips">
                          {data[f.key].map((val, i) => (
                            <span key={i} className="ep-view-chip">
                              {val}
                            </span>
                          ))}
                        </div>
                      ) : (
                        "Not specified"
                      )
                    ) : (
                      data[f.key] || "Not specified"
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}

      {/* EDIT MODE */}
      {editing && (
        <div className="ep-edit-form">
          <div className="ep-form-grid">
            {(section?.fields || []).map((f) => {
              //  condition: show cadre only for govt jobs
              if (
                f.key === "cadre" &&
                !["State Government", "Central Government"].includes(
                  draft.employmentType,
                )
              ) {
                return null;
              }

              return (
                <div key={f.key} className="ep-field">
                  <label className="ep-lbl">{f.label}</label>
                  {renderField(f)}
                </div>
              );
            })}
          </div>
          <div className="ep-form-actions">
            {saved && <span className="ep-toast">✓ Saved successfully</span>}
            <button
              className="ep-btn-cancel"
              onClick={handleCancel}
              disabled={saving}
            >
              Cancel
            </button>
            <button
              className="ep-btn-save"
              onClick={handleSave}
              disabled={saving}
            >
              {saving ? "Saving…" : "✓ Save"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// ---  >  About Section
function AboutSection({ data, onSave }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(data.about || "");
  const [saved, setSaved] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setDraft(data.about || "");
  }, [data.about]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave("about", { ...data, about: draft });
      setEditing(false);
      setSaved(true);
      setTimeout(() => setSaved(false), 2700);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="ep-section">
      <div className="ep-sec-header">
        <div className="ep-sec-left">
          <div className="ep-sec-icon" style={{ background: "#f0e8fd" }}>
            ✍️
          </div>
          <div>
            <div className="ep-sec-title">About Me</div>
            <div className="ep-sec-subtitle">
              Write something about yourself
            </div>
          </div>
        </div>
        <button
          className={`ep-edit-btn${editing ? " editing" : ""}`}
          onClick={() => {
            if (editing) {
              setEditing(false);
              setDraft(data.about || "");
            } else setEditing(true);
          }}
        >
          {editing ? "✕ Cancel" : "✎ Edit"}
        </button>
      </div>

      {!editing && (
        <div className="ep-about-text">
          {data.about || (
            <span className="ep-about-empty">
              Not written yet. Click Edit to add your story.
            </span>
          )}
        </div>
      )}

      {editing && (
        <div className="ep-edit-form">
          <div className="ep-form-grid one ep-about-grid">
            <div className="ep-field">
              <label className="ep-lbl">About Me</label>
              <textarea
                className="ep-textarea"
                value={draft}
                onChange={(e) => setDraft(e.target.value)}
                maxLength={400}
                placeholder="Write about yourself, your interests, family background, what you're looking for…"
              />
              <div className="ep-char">{draft.length}/300</div>
            </div>
          </div>
          <div className="ep-form-actions">
            {saved && <span className="ep-toast">✓ Saved successfully</span>}
            <button
              className="ep-btn-cancel"
              onClick={() => {
                setEditing(false);
                setDraft(data.about || "");
              }}
              disabled={saving}
            >
              Cancel
            </button>
            <button
              className="ep-btn-save"
              onClick={handleSave}
              disabled={saving}
            >
              {saving ? "Saving…" : "✓ Save"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// --- >  Preference Section
export function PreferenceSection() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetch = async () => {
      try {
        await dispatch(getProfile()).unwrap();
      } catch (err) {
        toast.error(
          err || err?.message || "Failed to load profile. Please try again.",
        );
      }
    };
    fetch();
  }, [dispatch]);

  return (
    <div className="ep-section glow-gradient">
      <div className="ep-sec-header flex-wrap gap-3">
        <div className="ep-sec-left flex-grow-1">
          <div className="ep-sec-icon" style={{ background: "#e6f4ff" }}>
            ❤️
          </div>
          <div className="ep-sec-text">
            <div className="ep-sec-title">Preferences</div>
            <div className="ep-sec-subtitle">
              Want a life partner who is caring, ambitious and understanding.
              Let's grow together and turn dreams into reality
            </div>
          </div>
        </div>
        <div className="ep-btn-wrapper">
          <button
            className="ep-btn-save"
            onClick={() => navigate("/user/partner-preference")}
          >
            ✎ Edit Preferences
          </button>
        </div>
      </div>
    </div>
  );
}

// Main Component
export default function EditProfile() {
  const dispatch = useDispatch();

  const [data, setData] = useState(initData);
  const {
    profilelist = {},
    loading,
    subCasteLoading,
  } = useSelector((state) => state.profile);

  const profilePhoto = profilelist?.profilePhoto || null;

  // Completion - >  calculation
  const radius = 42;
  const circumference = 2 * Math.PI * radius;

  const completionPercent = (() => {
    const profile = data?.profile || {};
    const profession = data?.profession || {};
    const family = data?.family || {};
    const permanent = profile?.permanentAddress || {};
    const present = profile?.presentAddress || {};

    const fields = [
      data.name,
      data.dob,
      data.gender,
      data.profileFor,
      data.maritalStatus,
      data.height,
      data.bloodGroup,
      data.complexion,
      data.Language?.length > 0,
      data.hobbies?.length > 0,
      data.subcaste,
      data.motherTongue,
      data.about,
      data.education,
      data.college,
      data.occupation,
      data.company,
      data.income,
      data.workLocation,
      data.employmentType,
      data.cadre,
      data.fatherName,
      data.motherName,
      data.fatherOcc,
      data.motherOcc,
      data.familyType,
      data.address,
      data.city,
      data.state,
      data.country,
      data.permanentAddress,
      data.permanentCity,
      data.nativeDistrict,
      data.permanentState,
      data.planningtoSettle,
      data.country,
      data.staying,
      data.photo?.length > 0,
    ];
    const filled = fields.filter((v) => v && v !== "").length;
    return Math.round((filled / fields.length) * 100);
  })();

  const strokeOffset =
    circumference - (completionPercent / 100) * circumference;

  useEffect(() => {
    const fetch = async () => {
      try {
        await dispatch(getProfile()).unwrap();
      } catch (err) {
        toast.error(
          err || err?.message || "Failed to load profile. Please try again.",
        );
      }
    };
    fetch();
  }, [dispatch]);

  useEffect(() => {
    if (profilelist && Object.keys(profilelist).length > 0) {
      setData(mapProfile(profilelist));
    }
  }, [profilelist]);

  const handleSectionSave = async (sectionKey, patch) => {
    setData((d) => ({ ...d, ...patch }));

    const result = mapSectionToPayload(sectionKey, patch);
    const profileId = profilelist?.id || profilelist?._id;

    if (!result || !profileId) return;

    const { actionType, payload } = result;

    try {
      let res;
      if (actionType === "updateProfile") {
        res = await dispatch(
          updateProfile({ id: profileId, ...payload }),
        ).unwrap();
      } else if (actionType === "updateFamilyDetails") {
        res = await dispatch(
          updateFamilyDetails({ id: profileId, ...payload }),
        ).unwrap();
      } else if (actionType === "updateProfessionalDetails") {
        res = await dispatch(
          updateProfessionalDetails({ id: profileId, ...payload }),
        ).unwrap();
      }
      await dispatch(getProfile()).unwrap();
      toast.success(res?.message || "Updated successfully!");
    } catch (err) {
      toast.error(err || err?.message || "Failed to update. Please try again.");
    }
  };

  return (
    <>
      <div className="ep-root">
        {/* Hero */}
        <div className="ep-hero glow-gradient">
          <div className="ep-profile-wrapper">
            <div className="ep-profile-avatar">
              {profilePhoto ? (
                <img
                  src={profilePhoto}
                  alt="profile"
                  className="ep-profile-img"
                />
              ) : (
                <span className="ep-avatar-letter">
                  {data.name ? (
                    data.name.trim().charAt(0).toUpperCase()
                  ) : (
                    <CgProfile />
                  )}
                </span>
              )}
            </div>
            {/* <button className="ep-camera-btn">📷</button> */}
          </div>

          <div className="ep-hero-info">
            <div className="ep-hero-name">{data.name}</div>
            <div className="ep-hero-meta">
              {data.dob
                ? `${new Date().getFullYear() - new Date(data.dob).getFullYear()} yrs`
                : ""}
              {data.height && ` · ${data.height}`}
              {(data.city || data.state) &&
                ` · ${[data.city, data.state].filter(Boolean).join(", ")}`}
            </div>
            {(data.education || data.income) && (
              <div className="ep-hero-meta" style={{ marginTop: "4px" }}>
                {[data.education, data.income].filter(Boolean).join(" · ")}
              </div>
            )}

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "left",
                alignItems: "left",
                gap: "6px",
                marginTop: "10px",
              }}
            >
              <span className="ep-hero-chip">✓ Premium Member</span>

              {data.occupation && (
                <span className="ep-hero-chip">{data.occupation}</span>
              )}

              {profilelist?.profileVerified ? (
                <span className="ep-hero-chip ep-chip-profile">
                  ✓ Profile Verified
                </span>
              ) : (
                <span className="ep-hero-chip ep-chip-profile-no">
                  ✗ Profile Not Verified
                </span>
              )}

              {profilelist?.aadhaarVerified ? (
                <span className="ep-hero-chip ep-chip-aadhaar">
                  ✓ Aadhaar Verified
                </span>
              ) : (
                <span className="ep-hero-chip ep-chip-aadhaar-no">
                  ✗ Aadhaar Not Verified
                </span>
              )}
            </div>
          </div>

          <div className="ep-completeness">
            <svg width="110" height="110" viewBox="0 0 110 110">
              <circle
                cx="55"
                cy="55"
                r={radius}
                fill="none"
                stroke="rgba(255,255,255,0.15)"
                strokeWidth="8"
              />

              <circle
                cx="55"
                cy="55"
                r={radius}
                fill="none"
                stroke="#F5C518"
                strokeWidth="8"
                strokeDasharray={circumference}
                strokeDashoffset={strokeOffset}
                strokeLinecap="round"
                transform="rotate(-90 55 55)"
              />

              <text
                x="55"
                y="61"
                textAnchor="middle"
                fontSize="18"
                fontWeight="700"
                fill="white"
                fontFamily="sans-serif"
              >
                {completionPercent}%
              </text>
            </svg>
            <div className="ep-comp-lbl">Complete</div>
          </div>
        </div>

        {/* Section Cards */}
        {loading ? (
          <Container style={{ width: "60%" }}>
            <div className="ep-skeleton">
              {[1, 2, 3].map((i) => (
                <div key={i} className="ep-skeleton-card">
                  <div className="ep-skeleton-title" />
                  <div className="ep-skeleton-line" />
                  <div className="ep-skeleton-line short" />
                </div>
              ))}
            </div>
          </Container>
        ) : (
          sections.map((sec) => (
            <SectionCard
              key={sec.key}
              section={sec}
              data={data}
              onSave={handleSectionSave}
            />
          ))
        )}

        <AboutSection data={data} onSave={handleSectionSave} />
        <PreferenceSection />
      </div>
    </>
  );
}